import React, { FC, Fragment } from 'react'
import { icon as LeafletIcon } from 'leaflet'
import { Marker as LeafMarker, MarkerProps as LeafletMarkerProps } from 'react-leaflet'
import { renderToStaticMarkup } from 'react-dom/server'
import { Popup } from './Popups'
import LocationIcon from '@foros-fe/assets/icons/location-gold.svg'

type Props = LeafletMarkerProps & {
  popup?: string
}

const iconUrl =
  'data:image/svg+xml,' +
  encodeURIComponent(renderToStaticMarkup(<LocationIcon width={51} height={51} />))

export const icon = LeafletIcon({
  iconUrl,
  iconRetinaUrl: iconUrl,
  iconSize: [51, 51],
  className: 'filter drop-shadow-marker',
  iconAnchor: [25.5, 51],
  popupAnchor: [0, -25.5],
})

const addLineBreaks = (content: string) =>
  content.split('\n').map((text, index) => (
    <Fragment key={`${text}-${index}`}>
      {text}
      <br />
    </Fragment>
  ))

const Marker: FC<Props> = ({ position, popup }) => {
  return (
    <LeafMarker icon={icon} position={position}>
      {popup && <Popup>{addLineBreaks(popup)}</Popup>}
    </LeafMarker>
  )
}

export default Marker
